
<template>
  <div class="col-md-12 d-flex justify-content-center">
    <!-- Login form -->
    <section class=" container1-form center-form">
      <h1 class="title1-form">Connexion</h1>
      <!-- Form itself -->
      <VeeForm @submit="handleLogin" :validation-schema="schema">
        <!-- Username -->
        <div class="form-group">
          <label class="content1-form" for="username">Utilisateur</label>
          <Field name="username" type="text" class="form-control" />
          <ErrorMessage name="username" class="error-feedback" />
        </div>
        <!-- Password -->
        <div class="form-group">
          <label class="content1-form" for="password">Mot de passe</label>
          <Field name="password" type="password" class="form-control" />
          <ErrorMessage name="password" class="error-feedback" />
        </div>
        <!-- Submit button -->
        <div class="button-form form-group">
          <button class="btn btn-primary btn-block  btn-lg" :disabled="loading">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
            <span>Se connecter</span>
          </button>
        </div>
        <!-- Possible message -->
        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </VeeForm>
    </section>
  </div>
</template>

<script>
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
  name: "login-page",
  components: {
    VeeForm,
    Field,
    ErrorMessage,
  },
  data() {
    const schema = yup.object().shape({
      username: yup.string().required("Le nom d'utilisateur est requis !"),
      password: yup.string().required("Le mot de passe est requis !"),
    });
    return {
      loading: false,
      message: "",
      schema,
    };
  },
  computed: {
    // Returns whether the user is logged in
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  methods: {
    // Manages the user's login
    handleLogin(user) {
      this.loading = true;
      this.$store.dispatch("auth/login", user).then(
        () => {
          this.$router.push("/home");
        },
        (error) => {
          this.loading = false;
          this.message = (error.response && error.response.data &&error.response.data.message) || error.message || error.toString();
        }
      );
    },
  },
  created() {
    if (this.loggedIn) { // User is logged in
        this.$router.push("/home");
    }
  }
}
</script>
